import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry')({
  component: undefined,
  context: () => ({
    getBreadcrumbData: () => ({
      id: null,
      translationKey: null,
    }),
  }),
  beforeLoad: ({ location }) => {
    if (location.pathname === '/registry') {
      throw redirect({
        to: '/dashboard',
      });
    }
  },
});
